/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-filename-extension */
import { Box } from "@mui/material";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IconClock2 from "../../../../../public/assets/icons/IconClock2";
import { commonActions } from "../../redux/actions";
import { TCommonState } from "../../utils/type";

type TProps = {
  startTime: any;
  endTime?: any;
  quizTime?: number;
  isArena?: boolean;
  onComplete: () => void;
  isQuizTime?: boolean;
  isIpad?: boolean;
  isDialogResult?: boolean;
};

// time truyen vao la seconds
function CountdownStartTime({
  startTime,
  endTime,
  quizTime,
  onComplete,
  isArena = false,
  isQuizTime = false,
  isIpad = false,
  isDialogResult = false
}: TProps) {
  const dispatch = useDispatch();

  const diffTimeSeconds = useSelector((state: { commonNew: TCommonState }) => state.commonNew.diffTimeSeconds);
  const getTimeCountDownSeconds = useCallback(() => {
    if (!quizTime && Number.isInteger(startTime)) {
      // button countdown detail room
      return moment.unix(startTime).diff(moment().subtract(diffTimeSeconds, "seconds"), "seconds");
    }
    // button countdown quiz
    return isArena
      ? moment(endTime).diff(moment().subtract(diffTimeSeconds, "seconds"), "seconds")
      : moment(startTime).add(quizTime, "minutes").diff(moment(), "seconds");
  }, [diffTimeSeconds]);
  const [times, setTime] = useState(getTimeCountDownSeconds());

  useEffect(() => {
    let interval;
    if (times === 0) {
      onComplete();
    } else {
      interval = setInterval(() => {
        setTime(getTimeCountDownSeconds());
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [times, getTimeCountDownSeconds]);

  // tracking user change time local, if time update too large => get timeserver to re-calculate diffTimeSeconds
  useEffect(() => {
    let previousTime = moment().unix();
    const intervalId = setInterval(() => {
      const currentTime = moment().unix();
      if (Math.abs(previousTime - currentTime) > 3) {
        dispatch(commonActions.getTimeServer());
      }
      previousTime = currentTime;
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const secondsToTime = (secs) => {
    if (secs <= 0) return { hours: 0, minutes: 0, seconds: 0 };
    const hours = Math.floor(secs / (60 * 60));
    const divisorForMinutes = secs % (60 * 60);
    const minutes = Math.floor(divisorForMinutes / 60);
    const divisorForSeconds = divisorForMinutes % 60;
    const seconds = Math.ceil(divisorForSeconds);

    return {
      hours,
      minutes,
      seconds
    };
  };
  const { hours, minutes, seconds } = secondsToTime(times);
  if (isQuizTime) {
    return (
      <Box style={{ display: "flex", alignItems: "center" }}>
        {isIpad && !isDialogResult && <IconClock2 />}
        <span
          style={{
            marginLeft: isIpad ? 6 : 0
          }}
        >
          {hours < 10 ? `0${hours}` : hours}:{minutes < 10 ? `0${minutes}` : minutes}:
          {seconds < 10 ? `0${seconds}` : seconds}
        </span>
      </Box>
    );
  }
  return (
    <span>
      {hours < 10 ? `0${hours}` : hours}:{minutes < 10 ? `0${minutes}` : minutes}:
      {seconds < 10 ? `0${seconds}` : seconds}
    </span>
  );
}

export default CountdownStartTime;
